<template>
  <mi-dialog
    :model-value="deleteModal"
    :custom-design-dialog="true"
    class="delete-modal-dialog"
    no-backdrop-dismiss
  >
    <div class="delete-modal-dialog-wrapper">
      <div class="delete-modal-wrapper">
        <div class="delete-modal-confirmation-btn">
          <h3 class="q-mt-none q-mb-none delete-modal-header"> Delete from Saved collection? </h3>
          <div class="delete-modal-close-icon">
            <mi-btn
              icon="close"
              icon-type
              icon-size="21px"
              fab
              flat
              @click="closeDeleteModal"
            ></mi-btn>
          </div>
        </div>

        <p class="q-mb-xl">
          Delete this collection from Saved collections. You will not be able to access it again in the future.
        </p>
      </div>

      <div class="delete-modal-btns-wrapper">
        <mi-btn flat @click="closeDeleteModal"> Cancel </mi-btn>
        <mi-btn @click="deleteCollections(selectedRow.id)"> Yes, delete </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  export default {
    name: 'DeleteModal',
    props: {
      deleteModal: {
        type: Boolean,
        required: true
      },
      selectedRow: {
        type: Object,
        required: true
      },
      deleteCollections: {
        type: Function,
        required: true
      },
      closeDeleteModal: {
        type: Function,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  // stylelint-disable declaration-no-important
  .delete-modal-dialog-wrapper {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .delete-modal-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .delete-modal-confirmation-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .delete-modal-btns-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .send-to-search-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
  }
</style>
